var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"drop":function($event){$event.preventDefault();return _vm.droppedFiles.apply(null, arguments)},"dragover":function($event){$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }